import React, { useState } from 'react';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { TID } from '@/constants/testIds';

export const Footer = () => {
  const [email, setEmail] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email.includes('@')) {
      toast.error('Enter a valid email');
      return;
    }
    toast.success('Welcome to the list ✿');
    setEmail('');
  };

  return (
    <footer
      data-testid={TID.footer}
      className="pt-20 pb-12"
      style={{ backgroundColor: '#0F1B2A', color: '#E8EEF6' }}
    >
      <div className="cw-container">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-heading text-2xl font-medium">CHOCO-WASH</div>
            <a
              href="https://www.choco-wash.com"
              className="mt-1 inline-block text-sm text-[#A8B6C6] hover:text-white transition"
            >
              www.choco-wash.com
            </a>
            <p className="mt-3 text-sm leading-relaxed text-[#A8B6C6] max-w-xs">
              Small batch soap and bean-to-bar chocolate, hand-poured in a
              sunlit studio in Nagpur, India. Shipped pan-India.
            </p>
          </div>

          <div className="md:col-span-3 text-sm">
            <div className="cw-label" style={{ color: '#A8B6C6' }}>Shop</div>
            <ul className="mt-4 space-y-2 text-[#E8EEF6]/85">
              <li><a href="#soaps" className="hover:text-white">Soaps</a></li>
              <li><a href="#chocolates" className="hover:text-white">Chocolates</a></li>
              <li><a href="#hampers" className="hover:text-white">Hampers</a></li>
              <li><a href="#story" className="hover:text-white">Our Story</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="cw-label" style={{ color: '#A8B6C6' }}>Newsletter</div>
            <p className="text-sm mt-3 text-[#A8B6C6]">
              One slow letter a month. New bars, the studio, no spam.
            </p>
            <form onSubmit={onSubmit} className="mt-4 flex gap-2">
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="h-12 rounded-full bg-white/10 border-white/20 text-white placeholder:text-[#A8B6C6] focus-visible:ring-[var(--cw-blue)]"
                data-testid={TID.newsletterInput}
              />
              <button
                type="submit"
                className="cw-btn-primary h-12"
                data-testid={TID.newsletterSubmit}
              >
                Join
              </button>
            </form>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[#A8B6C6]">
          <div>© {new Date().getFullYear()} CHOCO-WASH Studio · Nagpur, India. Made slowly.</div>
          <div className="flex gap-5">
            <a href="#story" className="hover:text-white">Privacy</a>
            <a href="#story" className="hover:text-white">Terms</a>
            <a href="#contact" className="hover:text-white">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
